import React, { useState } from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  styled,
  useMediaQuery,
} from "@mui/material";
import { formattedAmountWithoutAed } from "../../../../utils/CommonFunction";
import { useTheme } from "@emotion/react";

export const getStatusDisplayText = (text) => {
  if (typeof text !== "string") return text;
  const displayText = text
    .replace(/[-_]/g, " ")
    .toLowerCase()
    .split(" ")
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(" ");
  return displayText;
};

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  borderBottom: "none",
  textTransform: "capitalize",
}));

const MobileView = ({ details }) => {
  return (
    <div
      style={{ padding: "2vh 0", backgroundColor: "#fff", minHeight: "100vh" }}
    >
      <div>
        <div style={{ display: "flex", flexDirection: "column", gap: "12px" }}>
          <div
            style={{
              backgroundColor: "#fff",
              borderRadius: "8px",
              padding: "8px",
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <span style={{ fontSize: "14px", color: "#666" }}>
              Initial Deposit Need By contractor (%)
            </span>
            <span
              style={{ fontSize: "14px", fontWeight: "500", color: "#333" }}
            >
              {details?.project_fees?.Initial_deposit_needed_by_contractor ||
                "-"}
            </span>
          </div>

          <div
            style={{
              backgroundColor: "#fff",
              borderRadius: "8px",
              padding: "8px",

              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <span style={{ fontSize: "14px", color: "#666" }}>
              Warranty withheld amount (%)
            </span>
            <span
              style={{ fontSize: "14px", fontWeight: "500", color: "#333" }}
            >
              {details?.project_fees?.completion_of_the_warranty_period || "-"}
            </span>
          </div>

          <div
            style={{
              backgroundColor: "#fff",
              borderRadius: "8px",
              padding: "8px",

              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <span style={{ fontSize: "14px", color: "#666" }}>
              Delay Guarantee (%)
            </span>
            <span
              style={{ fontSize: "14px", fontWeight: "500", color: "#333" }}
            >
              {details?.project_fees?.project_completion || "-"}
            </span>
          </div>

          <div
            style={{
              backgroundColor: "#fff",
              borderRadius: "8px",
              padding: "8px",

              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <span style={{ fontSize: "14px", color: "#666" }}>
              Delay withheld amount (%)
            </span>
            <span
              style={{ fontSize: "14px", fontWeight: "500", color: "#333" }}
            >
              {details?.project_fees?.deposit_for_delay_guarantees || "-"}
            </span>
          </div>

          <div
            style={{
              backgroundColor: "#fff",
              borderRadius: "8px",
              padding: "8px",

              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <span style={{ fontSize: "14px", color: "#666" }}>
              Warranty Period
            </span>
            <span
              style={{ fontSize: "14px", fontWeight: "500", color: "#333" }}
            >
              {details?.project_fees?.warranty_period}{" "}
              {details?.project_fees?.warranty_period_unit
                ?.toLowerCase()
                ?.replace(/^\w/, (c) => c.toUpperCase())}
            </span>
          </div>

          <div
            style={{
              backgroundColor: "#fff",
              borderRadius: "8px",
              padding: "8px",

              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <span style={{ fontSize: "14px", color: "#666" }}>
              Weekly Delay (%)
            </span>
            <span
              style={{ fontSize: "14px", fontWeight: "500", color: "#333" }}
            >
              {details?.project_fees?.weekly_delay || "-"}
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default function CommissionDetails({ details }) {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));

  if (isMobile) {
    return <MobileView details={details} />;
  }

  return (
    <TableContainer
      component={Paper}
      sx={{
        width: "45%",
        overflow: "none !important",
        boxShadow: "none",
        maxHeight: "87vh",
        marginTop: "2vh",
      }}
    >
      <Table
        sx={{
          "& thead": {
            "& th": {
              color: "#949DAA",
              fontWeight: "500",
            },
          },
          "& tbody": {
            "& tr:hover": {
              backgroundColor: "#f7f7f7",
            },
            "& tr": {
              borderBottom: "none",
            },
          },
        }}
      >
        {/* <TableHead>
          <TableRow>
            <StyledTableCell>Commission</StyledTableCell>
            <StyledTableCell sx={{ textAlign: "right" }}>
              <strong>Amount (AED)</strong>
            </StyledTableCell>
          </TableRow>
        </TableHead> */}
        <TableBody>
          <React.Fragment>
            <TableRow>
              <StyledTableCell>
                Initial Deposit Need By contractor (%):
              </StyledTableCell>
              <StyledTableCell sx={{ textAlign: "right" }}>
                <strong>
                  {details?.project_fees
                    ?.Initial_deposit_needed_by_contractor || "-"}
                </strong>
              </StyledTableCell>
            </TableRow>

            <TableRow>
              <StyledTableCell>Warranty withheld amount (%):</StyledTableCell>
              <StyledTableCell sx={{ textAlign: "right" }}>
                <strong>
                  {details?.project_fees?.completion_of_the_warranty_period ||
                    "-"}
                </strong>
              </StyledTableCell>
            </TableRow>

            <TableRow>
              <StyledTableCell>Delay Guarantee (%):</StyledTableCell>
              <StyledTableCell sx={{ textAlign: "right" }}>
                <strong>
                  {details?.project_fees?.project_completion || "-"}
                </strong>{" "}
              </StyledTableCell>
            </TableRow>

            <TableRow>
              <StyledTableCell>Delay withheld amount (%):</StyledTableCell>
              <StyledTableCell sx={{ textAlign: "right" }}>
                <strong>
                  {details?.project_fees?.deposit_for_delay_guarantees || "-"}
                </strong>
              </StyledTableCell>
            </TableRow>

            <TableRow>
              <StyledTableCell>Warranty Period:</StyledTableCell>
              <StyledTableCell sx={{ textAlign: "right" }}>
                <strong>
                  {details?.project_fees?.warranty_period}{" "}
                  {details?.project_fees?.warranty_period_unit
                    ?.toLowerCase()
                    ?.replace(/^\w/, (c) => c.toUpperCase())}
                </strong>
              </StyledTableCell>
            </TableRow>

            <TableRow>
              <StyledTableCell>Weekly Delay (%):</StyledTableCell>
              <StyledTableCell sx={{ textAlign: "right" }}>
                <strong>{details?.project_fees?.weekly_delay || "-"}</strong>
              </StyledTableCell>
            </TableRow>
          </React.Fragment>
        </TableBody>
      </Table>
    </TableContainer>
  );
}
